<template>
    <div element-loading-spinner="qc-spinner" :loading="loadingVerificationData" v-loading="loadingVerificationData" >
        <canvas id="verificationsGraph" class="canvas-container"></canvas>
    </div>
</template>
    
<script>
import Chart from "chart.js";
import { mapGetters, mapState } from "vuex";
import { utils, writeFile } from 'xlsx'
import moment from 'moment'
export default {
    name: "verifications-graph",
    components: {
        Chart,
    },
    data() {
        return {
            loadingVerificationData: false,
            sidebarStore: false,
            chart: "",
            chartName: "",
            verificationsData: null,
              chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Cancelled Verifications',
                        data: [],
                        backgroundColor:
                            'rgba(255, 99, 132, 0.2)',
                        borderColor:
                            'rgba(255, 99, 132)',
                        borderWidth: 1,
                        stack: 'Stack 0',
                    },
                    {
                        label: 'Not Verified Verifications',
                        data: [],
                        backgroundColor:
                            'rgba(54, 162, 235, 0.2)',
                        borderColor:
                            'rgba(54, 162, 235)',
                        borderWidth: 1,
                        stack: 'Stack 0',
                    },
                    {
                        label: 'Pending Verifications',
                        data: [],
                        backgroundColor:
                            'rgba(255, 159, 64, 0.2)',
                        borderColor:
                            'rgba(255, 159, 64)',
                        borderWidth: 1,
                        stack: 'Stack 0',
                    },
                    {
                        label: 'Action Required',
                        data: [],
                        backgroundColor:
                            'rgba(54, 162, 235, 0.2)',
                        borderColor:
                            'rgba(54, 162, 235)',
                        borderWidth: 1,
                        stack: 'Stack 0',
                    },
                    {
                        label: 'Verified Verifications',
                        data: [],
                        backgroundColor:
                            'rgb(80, 200, 120, 0.2)',
                        borderColor:
                            'rgb(80, 200, 120)',
                        borderWidth: 1,
                        stack: 'Stack 0',
                    },
                ]
              },
            chartOptions: {
                responsive: true,
                scales: {
                    yAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        stacked: true,
                        ticks: {
                            precision: 0,
                            suggestedMax: 5,
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        }
                    }]
                },
                maintainAspectRatio: true,
                legend: {
                    display: false
                },
            }
        };
    },
   async mounted() {
    this.$store.state.verificationsChartName = "Monthly (12)"
        this.chartName = this.$store.state.verificationsChartName
    },
    beforeDestroy() {
        this.$store.state.verificationsChartName = ""
    },
    methods: {
        async setVerificationsData() {
            this.loadingVerificationData = true
            this.counter = this.chartName.substring(0, this.chartName.length - 1).slice(-2)
            this.chartData.labels = []
            this.chartData.datasets[0].data = []
            this.chartData.datasets[1].data = []
            this.chartData.datasets[2].data = []
            this.chartData.datasets[3].data = []
            this.chartData.datasets[4].data = []
            await this.$api.getVerificationsData(this.counter)
                .then(response => {
                    this.verificationsData = response.data
                    for (let i = 0; i < this.verificationsData.length; i++) {
                        if (this.counter == 52) {
                            var s = this.verificationsData[i].date.split(" ")
                            this.chartData.labels.push(moment().day("Monday").week(s[0]).format("Do MMM"))
                        } else {
                            this.chartData.labels.push(this.verificationsData[i].date)
                        }
                        this.chartData.datasets[0].data.push(this.verificationsData[i].cancelledCount)
                        this.chartData.datasets[1].data.push(this.verificationsData[i].notVerifiedCount)
                        this.chartData.datasets[2].data.push(this.verificationsData[i].pendingCount)
                        this.chartData.datasets[3].data.push(this.verificationsData[i].actionRequiredCount)
                        this.chartData.datasets[4].data.push(this.verificationsData[i].verifiedCount)
                    }
                    if (this.chart != "") {
                        this.loadingRevenueData = false
                        this.chart.update()
                    } else {
                        this.chartConstructor();
                    }
                    this.loadingVerificationData = false;
                }).catch(error => {
                    console.log("ERROR", error)
                })
        },
        chartConstructor() {
            const chartElement = document.getElementById("verificationsGraph");
                this.chart = new Chart(chartElement, {
                    type: "bar",
                    data: this.chartData,
                    options: this.chartOptions,
                });
            this.loadingVerificationData = false
        },
        downloadData() {
            let downloadData = {
                date: [],
                cancelled: [],
                notVerified: [],
                pending: [],
                actionRequired: [],
                verified: [],
            }
            for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
                downloadData.date.push(this.chartData.labels[i])
                downloadData.cancelled.push(this.chartData.datasets[0].data[i])
                downloadData.notVerified.push(this.chartData.datasets[1].data[i])
                downloadData.pending.push(this.chartData.datasets[2].data[i])
                downloadData.actionRequired.push(this.chartData.datasets[3].data[i])
                downloadData.verified.push(this.chartData.datasets[4].data[i])
            }
            const data = downloadData.date.map((date, i) => ({
                Date: date,
                "Cancelled Verifications": downloadData.cancelled[i],
                "Not Verified Verifications": downloadData.notVerified[i],
                "Pending Verifications": downloadData.pending[i],
                "Action Required Verifications": downloadData.actionRequired[i],
                "Verified Verifications": downloadData.verified[i],
            }));
            const worksheet = utils.json_to_sheet(data);
            const workbook = utils.book_new()
            utils.book_append_sheet(workbook, worksheet, "Verifications Data")
            writeFile(workbook, "Verification_Data.xlsx")
        },
    },
    computed: {
        ...mapState(["verificationsChartName", "downloadVerificationsSheet"]),
        ...mapGetters({
            newVerificationsChart: "getVerificationsChartName",
            newDownloadVerificationsSheet: "getDownloadVerificationsSheet"
        }),
    },
    watch: {
        newVerificationsChart: async function (val) {
            this.chartName = val
            this.setVerificationsData()
        },
        newDownloadVerificationsSheet: function (val) {
            if (val == true) {
                this.downloadData()
            }
            this.$store.state.downloadVerificationsSheet = false;
        }
    },
};
</script>